import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import ReactPixel from 'react-facebook-pixel';
import { App } from './App';
// Meta Pixel — initialize and track PageView
ReactPixel.init('1012782631449952');
ReactPixel.pageView();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-294" />);
}